import {
  FloatingButtonActionType,
  IFloatingButtonConfig,
} from '../ui/components/enhanced-web-chat-widget/floating-buttons/types';
import {
  ICustomFloatingButtonCFM,
  IFalconContentCFM,
  IFeatureAppContent,
} from './feature-service-types';

export const customFloatingButtonMapper = (
  customFloatingButton: ICustomFloatingButtonCFM,
): IFloatingButtonConfig => {
  return {
    type:
      customFloatingButton.fields.floatingButtonType === 'chat_message'
        ? FloatingButtonActionType.CHAT_MESSAGE
        : FloatingButtonActionType.EXTERNAL_LINK,
    value: customFloatingButton.fields.floatingButtonActionValue,
    label: customFloatingButton.fields.floatingButtonLabel,
    altLabel: customFloatingButton.fields.floatingButtonAltLabel,
    allowedUrls: customFloatingButton.fields.allowedUrls || [],
    excludedUrls: customFloatingButton.fields.excludedUrls || [],
  };
};

export const falconToAppContentMapper = (content: IFalconContentCFM): IFeatureAppContent => {
  const { fields } = content;
  const appContentTransformed: IFeatureAppContent = {
    chatWidget: {
      showFloatingButtons: fields.showFloatingButtons,
      showFloatingButtonsOnWindowOpen: fields.showFloatingButtonsOnWindowOpen,
      floatingButtonsContainerPosition: fields.floatingButtonsContainerPosition,
      floatingButtonsPosition: {
        closed: {
          bottom: `${fields.onWindowIsClosedFloatingButtonsContainerVerticalPosition}px`,
          [fields.floatingButtonsContainerPosition]: `${fields.onWindowIsClosedFloatingButtonsContainerHorizontalPosition}px`,
        },
        open: {
          bottom: `${fields.onWindowIsOpenFloatingButtonsContainerVerticalPosition}px`,
          [fields.floatingButtonsContainerPosition]: `${fields.onWindowIsOpenFloatingButtonsContainerHorizontalPosition}px`,
        },
      },
      widgetButtonPosition: fields.widgetButtonPosition,
      widgetChatWindowHorizontalPosition: fields.widgetChatWindowHorizontalPosition,
      allowedUrls: fields.allowedUrls,
      excludedUrls: fields.excludedUrls,
      restrictSessionOnMessagingChannel: fields.restrictSessionOnMessagingChannel,
      shouldMinimizeWindowOnNewTab: fields.shouldMinimizeWindowOnNewTab,
      bootDelaySeconds: fields.bootDelaySeconds ?? 0,
    },
    floatingButtons: { buttons: fields.customFloatingButtons.map(customFloatingButtonMapper) },
  };

  return appContentTransformed;
};
